// Browse macro-aware loader (P4).
//
// Behavior contract: this loader ONLY ever calls the supplied macro-aware
// fetcher. On failure it MUST NOT silently fall back to the generic /meals
// endpoint — that endpoint carries materially different safety/preference
// metadata (allergen/dislike recognition, macro-aware ordering). Instead it
// routes the failure to `onError` so the caller can show an explicit
// error + retry state.
export function loadBrowseMeals(fetchMacroAware, handlers) {
  var onSuccess = (handlers && handlers.onSuccess) || function() {};
  var onError = (handlers && handlers.onError) || function() {};
  return Promise.resolve()
    .then(function() { return fetchMacroAware(); })
    .then(function(res) {
      var data = (res && res.data) || {};
      // Forward-compatible: preserve the ENTIRE macro-aware response (targets_ready,
      // goal, ranges, day_complete, base_totals/pcts, remaining_exact, current_*,
      // on_track_count, best_rank_tier, filter_categories_selected, best_match_count,
      // per-candidate projected data, ...) so the Swap statuses/header/filters get
      // their required contract and future backend fields are never silently dropped.
      onSuccess(Object.assign({}, data, {
        meals: data.meals || [],
      }));
      return { ok: true };
    })
    .catch(function(error) {
      onError(error);
      return { ok: false };
    });
}
